
import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Autocomplete
} from 'formik-mui';
import { fetchAPI } from "@/utility/NetworkUtils";
import {
  Button,
  Stack,
  TextField as MuiTextField,
  FormControlLabel,
  Switch,
  TextareaAutosize
} from "@mui/material"
import ReceivingListTrackingNumberForm from "./ReceivingListTrackingNumberForm";
import { isJaguar, isSuperadmin, isClient } from "../../utility/UserUtils"
import { useConfirm } from 'material-ui-confirm';
const ReceivingListForm = ({
  item,
  user={},
  recievingItem = null,
  onCancel = () => {},
  onSubmit = () => {},
  events = [],
  deleteItem
}) => {
  const confirm = useConfirm();
  const [ showBulkTrackingNumberImport, setShowBulkTrackingNumberImport ] = useState(false);
  const [ bulkTrackingNumberValue, setBulkTrackingNumberValue ] = useState("");
  const generateDefaultTrackingNumberObject = () => {
    return {
      tracking_number: "",
      status: "",
      courier: "",
      temporary_id: "temp-" + Math.random()* 100000000,
      tracking_data: {},
      tracking_response: {}
    }
  }

  const getInitialValues = () => {
    if(recievingItem) {
      return {
        receiving_item: {
          id: recievingItem.id,
          ordered: recievingItem.ordered,
          event_id: recievingItem.event_id,
          notes: recievingItem.notes,
          archived_at: recievingItem.archived_at,
        },
        receiving_item_tracking_numbers: recievingItem.receiving_item_tracking_numbers.map(x=> {
          return {
            id: x.id,
            tracking_number: x.tracking_number,
            courier: x.courier,
            override_tracking_url: x.override_tracking_url,
            temporary_id: x.id,
            has_item_logs: x.has_item_logs
          }
        })
      }
    }
    return {
      receiving_item: {
        item_id: item ? item.id : null,
        notes: "",
        ordered: 1,
        event_id: null,
        archived_at: null
      },
      receiving_item_tracking_numbers: [
        generateDefaultTrackingNumberObject()
      ]
    }
  }

  const renderForm = (formikProps) => {
    return (
      <Form>
        <div className="form-group">
          <label htmlFor="ordered">Ordered</label>
          <Field
            type="number"
            name="receiving_item[ordered]"
            id="ordered"
            component={TextField}
            sx={{
              width: "100%"
            }}
          />
 
        </div>
        {renderEventSelection(formikProps)}
        <div className="form-group">
         <label>Notes</label>
          <Field 
            name="receiving_item[notes]"
            id="notes"
            component={TextField}
            multiline
            rows={5}
            sx={{
              width: "100%"
            }}
          />
        </div>
        <Stack direction="column" spacing={1}>
          {renderTrackingNumbers(formikProps)}
        </Stack>
        {renderBulkTrackingNumberImport(formikProps)}
        <div>
        </div>
        <Button
          type="button"
          onClick={() => {
            formikProps.values.receiving_item_tracking_numbers.push(generateDefaultTrackingNumberObject())
            formikProps.setFieldValue("receiving_item_tracking_numbers", formikProps.values.receiving_item_tracking_numbers)
          }}
        >
          + Add Tracking Number
        </Button>
        <Button 
          type="button"
          onClick={() => {
            setShowBulkTrackingNumberImport(!showBulkTrackingNumberImport)
          }}
        >
          Bulk Import Tracking Numbers
        </Button>
        {renderButtons(formikProps)}
      </Form>
    )
  }

  const renderArchivedAt = (formikProps) => {
    if(isJaguar(user) || isSuperadmin(user)) {
    return (
      <FormControlLabel
        control={
          <Switch 
            checked={formikProps.values.receiving_item.archived_at != null}
            onChange={() => {
              formikProps.values.receiving_item.archived_at = formikProps.values.receiving_item.archived_at == null ? new Date() : null
              formikProps.setFieldValue("receiving_item.archived_at", formikProps.values.receiving_item.archived_at)
            }}
          />
        }
        label="Archived"
      />
      );
    }
  }

  const renderEventSelection = (formikProps) => {
    if(events && events.length > 0) {
      return (
        <>
        <label>Which Event is this for? (Optional)</label>
        <Field
          component={Autocomplete}
          name="receiving_item[event_id]"
          getOptionValue={(option) => option.id}
          options={
            events.filter(x=> x.archived_at == null || x.id == formikProps.values.receiving_item.event_id).map(x=> x.id)
          }
          getOptionLabel={(option) => {
            return (events.find(x=> x.id == option)||{}).name||""
          }}
          renderInput={(params) => < MuiTextField
            {...params}
            variant="outlined"
          />}
          fullWidth
          clearable
        />
        </>
      );
    }
  }

  const renderBulkTrackingNumberImport = (formikProps) => {
    if(showBulkTrackingNumberImport) {
      return (
        <div className="form-group">
          <label htmlFor="bulkTrackingNumber">Bulk Import Tracking Numbers (One Per Line)</label>
          <Field
            type="textarea"
            rows={5}
            name="bulkTrackingNumber"
            id="bulkTrackingNumber"
            component={TextField}
            multiline
            sx={{
              width: "100%"
            }}
            onChange={(e) => {
              setBulkTrackingNumberValue(e.target.value)
            }}
          />
          <Stack direction="row" spacing={1} className="mt-1">
            <Button
              type="button"
              variant="contained"
              onClick={() => {
                const splitTrackingNumbers = bulkTrackingNumberValue.split("\n").filter(x=>x && x.length > 0);
                const newTrackingNumbers = Array(splitTrackingNumbers.length).fill(generateDefaultTrackingNumberObject()).map((x,i) => {
                  x = generateDefaultTrackingNumberObject()
                  x.tracking_number = splitTrackingNumbers[i]
                  return x
                })
                formikProps.values.receiving_item_tracking_numbers = formikProps.values.receiving_item_tracking_numbers.concat(newTrackingNumbers)
                formikProps.setFieldValue("receiving_item_tracking_numbers", formikProps.values.receiving_item_tracking_numbers)
                setBulkTrackingNumberValue("")
                setShowBulkTrackingNumberImport(false)
              }}
            >
              Import
            </Button>
            <Button
              type="button"
              variant="outlined"
              onClick={() => {
                setShowBulkTrackingNumberImport(false)
              }}
            >
              Cancel Bulk Import
            </Button>
          </Stack>
        </div>
      )
    }
  }

  const renderTrackingNumbers = (formikProps) => {
    return formikProps.values.receiving_item_tracking_numbers.map((x, i) => 
      <ReceivingListTrackingNumberForm
        key={"tracking-number-" + x.temporary_id}
        formikProps={formikProps}
        index={i}
      />
    )

  }

  const attemptDelete = async () => {
    const { confirmed, reason } = await confirm({
      description: "Are you sure you want to delete this order? All items already received will remain in the inventory.",
      confirmationText: "Yes, Delete This.",
      cancellationText: "No"
    })
    if(confirmed) {
      deleteItem(recievingItem)
    }
  }

  const renderButtons = (formikProps) => {
    return (
      <div className="text-right">
        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-end"
        > 
          {deleteItem && isJaguar(user) && (recievingItem||{}).id ? (
            <Button
              type="button"
              variant="outlined"
              onClick={() => {
                attemptDelete()
              }}
            >
              Delete (Jaguars Only)
            </Button>
          ):""}
          <Button
            type="button"
            variant="outlined"
            onClick={onCancel}
          >
            Cancel
          </Button>
     
          <Button
            type="submit"
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </Stack>
      </div>
    )
  }


  const submitForm = (values, {
    setSubmitting
  }) => {

    let tempValues = JSON.parse(JSON.stringify(values))

    tempValues.receiving_item_tracking_numbers = values.receiving_item_tracking_numbers.filter(x=>
      x.id || x.tracking_number
    )
    try {
      fetchAPI(recievingItem ? `/webapi/receiving_items/${recievingItem.id}` : "/webapi/receiving_items", (json)=> {
        setSubmitting(false)
        if(!json.error) {

          onSubmit(json.receiving_item)
        }
      },{
        method: recievingItem ? "PATCH" : "POST",
        body: tempValues,
      })
    }
    catch(e) {
      console.log(e)
      alert("Error: " + e)
      setSubmitting(false)
    }
  }

  return (
    <div>
      <Formik
        initialValues={getInitialValues()}
        onSubmit={submitForm}
      >
        {(formikProps) => renderForm(formikProps)}
      </Formik>
    </div>
  )

}

export default ReceivingListForm